var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1097 4.20743C13.5475 4.54416 13.6294 5.17201 13.2926 5.60976L8.29262 12.1098C8.11717 12.3378 7.85196 12.4793 7.56481 12.4979C7.27765 12.5166 6.99637 12.4106 6.79289 12.2072L3.29289 8.70716C2.90237 8.31663 2.90237 7.68347 3.29289 7.29294C3.68342 6.90242 4.31658 6.90242 4.70711 7.29294L7.40178 9.98762L11.7074 4.39034C12.0441 3.95258 12.672 3.87069 13.1097 4.20743Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.b75228e40684c6e321ec1ee30a7fd7e9.svg";
export { ForwardRef as ReactComponent };